module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_save02-34c25cf17511fd9f8f50e00f8f2d08c9.svg";